import { type ReactElement } from 'react';
import type { Exercice } from '../game/training';

/* ═══════════════════════════════════════════════════════════════════════════
   L'ENTRAÎNEMENT.

   Deux nœuds du hangar débouchent ici : « Salle d'entraînement » (rejouer un
   boss déjà vaincu) et « Accès aux secteurs franchis » (reprendre un monde
   déjà terminé depuis son début).

   ⚠️ RIEN n'y est gagné : ni crédits, ni jalons, ni record. La règle n'est pas
   une pudeur, c'est ce qui empêche l'entraînement de devenir la façon la plus
   rentable de jouer. Sans elle, rejouer en boucle le boss du monde 3 — le plus
   lucratif du jeu — contournerait par la porte de service l'anti-farm des
   quatre-vingt-dix secondes, et une partie complète cesserait d'avoir un
   intérêt économique.

   ⚠️ On ne s'entraîne QUE sur ce qu'on a franchi. Un boss répétable sans
   l'avoir jamais atteint transformerait la salle en raccourci de contenu : elle
   supprime le trajet, jamais l'épreuve.
   ═══════════════════════════════════════════════════════════════════════════ */

// Le type vit dans `src/game/training.ts`, avec la règle qui le produit :
// l'écran affiche une liste, il ne décide pas de son contenu.
export type { Exercice } from '../game/training';

export function TrainingScreen({
  exercices,
  onStart,
  onBack,
}: {
  exercices: readonly Exercice[];
  onStart: (e: Exercice) => void;
  onBack: () => void;
}): ReactElement {
  return (
    <div className="screen training">
      <h2>ENTRAÎNEMENT</h2>
      <p>
        Aucun crédit, aucun jalon, aucun record. C’est le prix de pouvoir répéter — et ce qui
        garantit qu’une vraie partie reste la seule qui compte.
      </p>

      {exercices.length === 0 ? (
        // Le cas n'est pas une erreur : le joueur a acheté l'accès avant
        // d'avoir franchi quoi que ce soit. Lui dire pourquoi la liste est vide
        // vaut mieux qu'un écran blanc qui ressemble à une panne.
        <p>
          Rien à répéter pour l’instant. Un secteur s’ouvre ici une fois franchi, un boss une fois
          vaincu.
        </p>
      ) : (
        <div className="training-list">
          {exercices.map((e) => (
            <button key={e.id} className="drill" onClick={() => onStart(e)}>
              <span className="drill-titre">{e.titre}</span>
              <span className="drill-detail">{e.detail}</span>
            </button>
          ))}
        </div>
      )}

      <button className="btn btn-primary" onClick={onBack}>
        RETOUR
      </button>
    </div>
  );
}
